import apiClient from '../lib/api-client';

export const complimentaryService = {
  getComplimentaryServices: async (category = null) => {
    const params = {};
    if (category && category !== 'All') {
      params['filter[serviceCategory.name]'] = category;
    }
    const response = await apiClient.get('/affluent/services', { params });
    return response.data;
  },

  getComplimentaryServiceById: async (id) => {
    const response = await apiClient.get(`/affluent/service/${id}`);
    return response.data;
  },
};
